const MAX_SLUG_LENGTH = 40;

function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/** 'carrossel-<slug>.zip' (slug ≤ 40 chars), or 'carrossel.zip'. */
export function carouselZipName(clipName: string | null): string {
  const slug = slugify(clipName ?? '').slice(0, MAX_SLUG_LENGTH).replace(/-+$/, '');
  return slug ? `carrossel-${slug}.zip` : 'carrossel.zip';
}

/** 0-based index → 'slide-01.png'. */
export function slideFileName(index: number, ext: 'png' | 'jpg'): string {
  return `slide-${String(index + 1).padStart(2, '0')}.${ext}`;
}
